import { from, switchMap, tap } from 'rxjs';
import uuid from 'uuid-random';
// Constants / utils
import { PASSKEY_BROWSER_UUID_ID_KEY } from 'PasskeysApp/constants';
import { localStorageAvailable } from 'NewAngular/utils/local-storage-utils';
// Services
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class PasskeysService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
        // Passkey registration helper functions
        this.getRegistrationChallenge = () => {
            return this.ajaxService.getDataObserveBody(this.urlsService.PASSKEYS.REGISTER);
        };
        this.createCredentials = (challengeResponse) => {
            return from(navigator.credentials.create({
                publicKey: {
                    ...challengeResponse,
                    challenge: Uint8Array.from(challengeResponse.challenge),
                    user: {
                        ...challengeResponse.user,
                        id: Uint8Array.from(challengeResponse.user.id),
                    },
                },
            }));
        };
        this.register = (credentials) => {
            const attestationResponse = credentials.response;
            const clientJSONBytes = new Uint8Array(attestationResponse.clientDataJSON);
            const keyBytes = new Uint8Array(attestationResponse.getPublicKey());
            const authBytes = new Uint8Array(attestationResponse.getAuthenticatorData());
            const browserUuid = uuid();
            const registrationParams = {
                id: credentials.id,
                algorithm: attestationResponse.getPublicKeyAlgorithm(),
                publicKeyDer: btoa(String.fromCharCode(...keyBytes)),
                clientData: btoa(String.fromCharCode(...clientJSONBytes)),
                authData: btoa(String.fromCharCode(...authBytes)),
                browserUuid,
            };
            return this.ajaxService
                .postJsonDataObserveBody(this.urlsService.PASSKEYS.REGISTER, registrationParams)
                .pipe(tap(() => {
                localStorage.setItem(PASSKEY_BROWSER_UUID_ID_KEY, browserUuid);
            }));
        };
        this.getCredentials = (challengeResponse) => {
            return from(navigator.credentials.get({
                publicKey: {
                    challenge: Uint8Array.from(challengeResponse.challenge),
                },
            }));
        };
        this.login = (credentials) => {
            const assertionResponse = credentials.response;
            const jsonBytes = new Uint8Array(assertionResponse.clientDataJSON);
            const authBytes = new Uint8Array(assertionResponse.authenticatorData);
            const sigBytes = new Uint8Array(assertionResponse.signature);
            const userIdBytes = new Uint8Array(assertionResponse.userHandle);
            const loginData = {
                id: credentials.id,
                clientData: btoa(String.fromCharCode(...jsonBytes)),
                authData: btoa(String.fromCharCode(...authBytes)),
                signature: btoa(String.fromCharCode(...sigBytes)),
                userId: btoa(String.fromCharCode(...userIdBytes)),
            };
            // Find where to redirect
            const searchParams = new URLSearchParams(window.location.search);
            const next = searchParams.get('next') || '/dashboard/'; // Default to dashboard, so the server doesn't try to redirect to 'null'
            const url = this.urlsService.getUrl(this.urlsService.PASSKEYS.LOGIN, {}, { next });
            return this.ajaxService.postJsonDataObserveBody(url, loginData);
        };
    }
    getPasskeys() {
        return this.ajaxService.getDataObserveBody(this.urlsService.PASSKEYS.COLLECTION);
    }
    updatePasskey(passkeyId, params) {
        const url = this.urlsService.getUrl(this.urlsService.PASSKEYS.PASSKEY, { passkeyId });
        return this.ajaxService.putDataObserveBody(url, params);
    }
    deletePasskey(passkeyId, browserUuid) {
        const url = this.urlsService.getUrl(this.urlsService.PASSKEYS.PASSKEY, { passkeyId });
        return this.ajaxService.deleteDataObserveBody(url).pipe(tap(() => {
            if (localStorageAvailable() && browserUuid === localStorage.getItem(PASSKEY_BROWSER_UUID_ID_KEY)) {
                localStorage.removeItem(PASSKEY_BROWSER_UUID_ID_KEY);
            }
        }));
    }
    registerPasskey() {
        return this.getRegistrationChallenge().pipe(switchMap(this.createCredentials), switchMap(this.register));
    }
    authenticatePasskey() {
        return this.getLoginChallenge().pipe(switchMap(this.getCredentials), switchMap(this.login));
    }
    // Passkey authentication helper functions
    getLoginChallenge() {
        return this.ajaxService.getDataObserveBody(this.urlsService.PASSKEYS.LOGIN);
    }
}
PasskeysService.ɵfac = function PasskeysService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PasskeysService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
PasskeysService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PasskeysService, factory: PasskeysService.ɵfac, providedIn: 'root' });
